// extracted by mini-css-extract-plugin
export default {"label":"InputNormalEL_label__C0Dj0","noStepper":"InputNormalEL_noStepper__pHoKS","errorInput":"InputNormalEL_errorInput__3NPJ4","errorText":"InputNormalEL_errorText__+87G9"};